import LocalizedStrings from 'localized-strings';

/**
 * @todo Validate locales
 * @see https://linear.app/shine/issue/CAC-1053
 */
const locales = new LocalizedStrings({
  en: {
    format: {
      CSV: 'CSV',
      OFX: 'OFX',
      QIF: 'QIF',
    },
    includeBankStatements: 'Inclure les relevés bancaires',
    includeInvoices: 'Inclure les factures associés',
    includePersonalTransactions:
      'Inclure les transactions marquées comme personnelles',
    title: 'Type d’export',
  },
  fr: {
    format: {
      CSV: 'CSV',
      OFX: 'OFX',
      QIF: 'QIF',
    },
    includeBankStatements: 'Inclure les relevés bancaires',
    includeInvoices: 'Inclure les factures associés',
    includePersonalTransactions:
      'Inclure les transactions marquées comme personnelles',
    title: 'Type d’export',
  },
} as const);

export default locales;
